import type { ReactNode } from 'react'
import { Link } from 'react-router'

export function HeaderRoot(props: { children: ReactNode }) {
  return (
    <header className='h-16 border-stone-600 border-b border-dashed bg-base-3 px-6'>
      {/* Grid it, and make it full height */}
      <div className='mx-auto flex h-full max-w-7xl items-center justify-between'>
        <Link className='hover:base-6 font-bold' to='/'>
          pagespeedlog.com
        </Link>
        {props.children}
      </div>
    </header>
  )
}
